import request from '@/utils/request';
import config from '@/utils/config';

export async function getToken(cb) {
  if (_sdk_) {
    const unixtime = _sdk_.getnowunixTime();
    const { aid, asec } = config;
    return await request({
      url: '/api-common-accesstoken',
      method: 'post',
      data: {
        appid: aid,
        session: _sdk_.getSession(),
        sm: _sdk_.getSdkSecret(asec, unixtime),
        time: unixtime,
      },
    });
  }
}
